<script lang="ts">
import { onMount } from "svelte";
import { navigate } from "svelte-routing";
import { fetchResearchItems } from "../services/research";
    import { fade } from "svelte/transition";
    import { quintOut } from "svelte/easing";

export let activeCategory = "";
export let activeSubCategory = "";

const researchFetch = new Promise(async (resolve: (data: any[]) => void) => {
    let data = await fetchResearchItems();
    resolve(data);
});

onMount(async () => {
    data = await researchFetch;
    if (activeSubCategory != "ongoing" && activeSubCategory != "completed")
        activeSubCategory = "completed";
    if (!data.find(e => (e.category.replace(/\s/g, '-')).toLowerCase() == activeCategory)) 
        navigate(`/not-found`);
});

$: navigate(`/projects/${activeCategory}/${activeSubCategory}`);

let data;
let showSubCategoryDropDown: boolean = false;
let showCategoryDropDown: boolean = false;

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#await researchFetch}
    <!-- Loading Animatin -->
    <div class="content">
        <div class="loading-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
        </div>
    </div>
{:then researchData}
    <div class="top-background" style="background-image:url(/images/backgrounds/research/{activeCategory}.jpg); height: auto; min-height: 35vh" in:fade={{ easing: quintOut, duration: 1000 }}>
        <h1 class="page-title" style="text-transform:capitalize;">{activeCategory.replace(/-/g, ' ')} research</h1>

        <!-- Category selector in header  -->
        <div class="top-dropdown-wrapper">
            <div class="card">
                <div class="flex-wrapper category-selector">
                    <div class="active-item" class:opened={showSubCategoryDropDown} on:click={() => showSubCategoryDropDown = !showSubCategoryDropDown}>
                        <span>{activeSubCategory.replace(/-/g, ' ')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 24 24" xml:space="preserve">
                            <path d="M20.6,5.5l-8,8c-0.3,0.3-0.8,0.3-1.2,0l-8-8c-0.3-0.3-0.8-0.3-1.2,0L0.6,7.1C0.3,7.4,0.3,8,0.6,8.3l10.8,10.8
                                c0.3,0.3,0.8,0.3,1.2,0L23.4,8.3c0.3-0.3,0.3-0.8,0-1.2l-1.6-1.6C21.4,5.1,20.9,5.1,20.6,5.5z"/>
                        </svg>
                    </div>
                    {#if showSubCategoryDropDown}
                        <div class="options" transition:fade={{ duration: 100 }}>
                            <p on:click={() => {activeSubCategory = "ongoing"; showSubCategoryDropDown=false;}}>Ongoing</p>
                            <p on:click={() => {activeSubCategory = "completed"; showSubCategoryDropDown=false;}}>Completed</p>
                        </div>
                    {/if}
                </div>
                <div class="flex-wrapper category-selector">
                    <div class="active-item" class:opened={showCategoryDropDown} on:click={() => showCategoryDropDown = !showCategoryDropDown}>
                        <span>{activeCategory.replace(/-/g, ' ')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 24 24" xml:space="preserve">
                            <path d="M20.6,5.5l-8,8c-0.3,0.3-0.8,0.3-1.2,0l-8-8c-0.3-0.3-0.8-0.3-1.2,0L0.6,7.1C0.3,7.4,0.3,8,0.6,8.3l10.8,10.8
                                c0.3,0.3,0.8,0.3,1.2,0L23.4,8.3c0.3-0.3,0.3-0.8,0-1.2l-1.6-1.6C21.4,5.1,20.9,5.1,20.6,5.5z"/>
                        </svg>
                    </div>
                    {#if showCategoryDropDown}
                        <div class="options" transition:fade={{ duration: 100 }}>
                            {#each researchData as category}
                                <p on:click={() => {activeCategory = (category.category.replace(/\s/g, '-')).toLowerCase(); showCategoryDropDown=false;}}>{category.category}</p>
                            {/each}
                        </div>
                    {/if}
                </div>
                <h3 class="page-subtitle">Projects</h3>
            </div>
        </div>
    </div>
{/await}

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="content">
    <section id="research-items">
        <div class="selectable-list">
            {#await researchFetch then researchData}
                {@const filteredCategories = researchData.filter(e => e.category.toLowerCase() === activeCategory.replace(/-/g, ' '))}
                {@const filteredItems = (filteredCategories.length > 0) ? filteredCategories[0].items : false}
                {@const subCategorizedItems = (filteredItems) ? filteredItems.filter(e => e.status.toLowerCase() === activeSubCategory.replace(/-/g, ' ')) : []}

                <ul in:fade={{ easing: quintOut, duration: 1000 }}>
                    {#if subCategorizedItems.length > 0}
                        {#each subCategorizedItems as item (item)}
                            
                            <li on:click={() => {}}>
                                <div class="flex-item">
                                    {#if item.imageSrc}
                                        <img src={item.imageSrc} alt="Project">
                                    {:else}
                                        <img src="/images/research/default.jpg" alt="Project Default">
                                    {/if}
                                </div>
                                <div class="flex-item">
                                    <h4>{@html item.name}</h4>
                                    <p>{@html (item.summary.length > 1000) ? item.summary.substring(0, 1000) + "..." : item.summary}</p>
                                    <a href="/project/{item.id}" class="action-button">Read More</a>
                                </div>
                            </li>
                        {/each}
                    {:else}
                        <div class="no-results-container">
                            <img src="/images/icons/no-results.png" alt="no results">
                            <h3>Sorry, this category is empty.</h3>
                        </div>
                    {/if}
                </ul>
            {/await}
        </div>
    </section>
</div>




<style lang="sass">

@import "../consts.sass"
@include page-header()
@include action-button()
@include loading-spinner()
@include no-search-results-text()

.top-dropdown-wrapper .card
    display: inline-flex
    background-color: white
    margin: 2rem 0
    padding: 1rem 0
    box-sizing: border-box
    flex-direction: row
    border-radius: 3px
    align-items: center

    .page-subtitle
        margin: 0
        margin: 0 1.5rem

    .category-selector
        font-size: 1.2rem
        font-weight: 400
        position: relative
        margin-left: 1rem

        *
            -webkit-user-select: none
            -moz-user-select: none
            -ms-user-select: none
            user-select: none
            color: $color_ink

        .active-item
            text-transform: capitalize
            border-radius: 2px
            padding: 0.6rem 1.1rem
            box-sizing: border-box
            position: relative
            display: flex
            flex-direction: row
            align-items: center
            cursor: pointer
            background-color: rgba(0,0,0,0.1)
            transition: all 0.3s ease

            &.opened
                svg
                    transform: rotate(180deg)
                    -webkit-transform: rotate(180deg)

            &:hover
                background-color: rgba(0,0,0,0.15)

            svg
                width: 0.8rem
                margin-left: 0.6rem
                height: 100%
                transition: transform 0.2s ease
                -webkit-transition: transform 0.2s ease

        .options
            position: absolute
            background-color: white
            border-radius: 0px 0px 3px 3px
            padding: 0.7rem
            width: 100%
            box-sizing: border-box
            font-size: 1.1rem
            box-shadow: 1px 1px 8px rgba(0,0,0,0.2)
            z-index: 2
            overflow: hidden
            animation: drop-down-in 0.5s ease
            -webkit-animation: drop-down-in 0.5s ease

            p	
                width: 100%
                margin-bottom: 0
                box-sizing: border-box
                cursor: pointer
                padding: 0.6rem 0.6rem
                border-radius: 2px
                transition: background-color 0.2s ease
                -webkit-transition: background-color 0.2s ease
                -moz-transition: background-color 0.2s ease

                &:hover
                    background-color: rgba(0,0,0,0.05)
                
                &:not(:last-child)
                    border-bottom: 2px solid #f2f2f2

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .selectable-list ul
        list-style-type: none

        li
            display: flex
            flex-direction: row
            align-items: center
            margin-bottom: 2rem

            .flex-item:first-child
                height: 12rem
                flex: 0 0 17rem
                margin-right: 3rem
                border-radius: 0.2rem
                overflow: hidden

                img
                    width: 100%
                    height: 100%
                    object-fit: cover
    

</style>